import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
const eventTypeMap = {
    click: 'onClick',
    mousedown: 'onMouseDown',
    mouseup: 'onMouseUp',
    touchstart: 'onTouchStart',
    touchend: 'onTouchEnd'
};
const ClickAwayListener = ({ children, onClickAway, mouseEvent = 'click', nodeToIgnore = null }) => {
    const node = useRef(null);
    const bubbledEventTarget = useRef(null);
    const mountedRef = useRef(false);
    // https://github.com/facebook/react/issues/20074
    useEffect(() => {
        setTimeout(() => { mountedRef.current = true; }, 0);
        return () => { mountedRef.current = false; };
    }, []);
    useEffect(() => {
        const handleEvents = event => {
            if (!mountedRef.current)
                return;
            if ((node.current && node.current.contains(event.target)) || bubbledEventTarget.current === event.target)
                return;
            if (nodeToIgnore && nodeToIgnore.contains(event.target))
                return;
            onClickAway(event);
        };
        document.addEventListener(mouseEvent, handleEvents);
        return () => { document.removeEventListener(mouseEvent, handleEvents); };
    }, [mouseEvent, onClickAway, nodeToIgnore]);
    const handleBubbledEvents = type => event => {
        bubbledEventTarget.current = event.target;
        const handler = children === null || children === void 0 ? void 0 : children.props[type];
        if (handler)
            handler(event);
    };
    const handleChildRef = childRef => {
        node.current = childRef;
        const { ref } = children;
        if (typeof ref === 'function') {
            ref(childRef);
        }
        else if (ref) {
            ref.current = childRef;
        }
    };
    const mappedMouseEvent = eventTypeMap[mouseEvent];
    return React.Children.only(React.cloneElement(children, {
        [mappedMouseEvent]: handleBubbledEvents(mappedMouseEvent),
        ref: handleChildRef
    }));
};
ClickAwayListener.propTypes = {
    children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]).isRequired,
    onClickAway: PropTypes.func.isRequired,
    mouseEvent: PropTypes.oneOf(['click', 'mousedown', 'mouseup', 'touchstart', 'touchend']),
    nodeToIgnore: PropTypes.instanceOf(Element)
};
export { ClickAwayListener };
//# sourceMappingURL=ClickAwayListener.js.map